"use client";

import { useIntlayer } from "next-intlayer";

export default function CoursesPageHeader() {
  const { label, title, body } = useIntlayer("courses-page");

  return (
    <div className="relative container mx-auto px-4">
      <p className="text-xs font-semibold tracking-[0.3em] uppercase mb-4 text-[#0193cd]">
        {label}
      </p>
      <h1 className="text-5xl md:text-6xl font-semibold mb-4 text-foreground">{title}</h1>
      <p className="text-lg max-w-xl text-muted-foreground">{body}</p>
    </div>
  );
}
